import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetUserGroupQuery } from '../../../api/queries/getUserGroup';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import UserGroupInnerPage from './UserGroupInnerPage';

const UserGroupDetailsPage = () => {
    const { userGroupId } = useParams<{ userGroupId: string }>();

    const { data, loading } = useGetUserGroupQuery({
        fetchPolicy: 'cache-and-network',
        variables: { userGroupId },
    });

    const { permissions: accountPermissions } = useAccount();
    const userGroup = data?.userGroup;

    const company = useCompany(true);

    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.viewUserGroups]) &&
          hasPermissions(accountPermissions, [permissionKind.viewUserGroups])
        : hasPermissions(accountPermissions, [permissionKind.viewUserGroups]);

    if (!userGroup && loading) {
        return <LoadingElement />;
    }

    if (!userGroup || !hasPermission) {
        return <NotFoundResult />;
    }

    return <UserGroupInnerPage userGroup={userGroup} />;
};

export default UserGroupDetailsPage;
